import styled from 'styled-components'

export const TooltipContainer = styled.div`
	position: relative;
	display: inline-flex;
	align-items: center;
	cursor: help;
`

export const TooltipIcon = styled.span`
	font-size: 0.875rem;
	color: #6c757d;
	margin-left: 0.375rem;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 20px;
	height: 20px;
	background: transparent;
	transition: all 0.2s ease;

	&:hover {
		color: #495057;
	}
`

export const TooltipText = styled.div<{ $top: number; $left: number; $visible: boolean }>`
	position: fixed;
	top: ${({ $top }) => $top}px;
	left: ${({ $left }) => $left}px;
	visibility: ${({ $visible }) => ($visible ? 'visible' : 'hidden')};
	padding: 8px 12px;
	background: #2c3e50;
	color: white;
	font-size: 0.75rem;
	border-radius: 6px;
	z-index: 10000;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
	pointer-events: none;
	width: max-content;
	max-width: 320px;
	white-space: normal;
	text-align: left;
	line-height: 1.5;

	&::after {
		content: '';
		position: absolute;
		top: 100%;
		left: 50%;
		transform: translateX(-50%);
		border: 5px solid transparent;
		border-top-color: #2c3e50;
	}
`
